<template>
    <div class="land-about-second">
        <div class="container">
            <div class="land-section-title">
                <h2>{{salesCard.project_land_site.about_second_title}}</h2>
                <h3>{{salesCard.project_land_site.about_second_title_desc}}</h3>
            </div>
            <div class="land-about-desc-red">
                <p v-html="salesCard.project_land_site.about_second_desc_red"></p>
            </div>
        </div>
        <div class="land-about-second-img">
            <img :src="salesCard.project_land_site.about_second_img" alt="">
        </div>
        <div class="container">
            <div class="column-container-desc">
                <div class="col-left">
                    <div class="desc-col-html" v-html="salesCard.project_land_site.about_second_desc_left"></div>
                    <div class="col-icons" v-if="salesCard.project_land_site.about_second_icons != undefined && salesCard.project_land_site.about_second_icons.length > 0">
                        <div class="item-icon" v-for="(item, index) in salesCard.project_land_site.about_second_icons" :key="index">
                            <img :src="item.icon" alt="">
                        </div>
                    </div>
                </div>
                <div class="col-right">
                    <div class="desc-col-html" v-html="salesCard.project_land_site.about_second_desc_right"></div>
                </div>  
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-about-second',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-about-second.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-about-second-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>